import { restApiHttpClient } from '@/helpers/rest-api-http-client';
import { Workflow } from '@/models/workflow';

export class WorkflowsRepository {
  constructor() {
  }

  static async getWorkflows() {
    const response = await restApiHttpClient.get('workflows');
    return response.data.map(workflow => new Workflow(workflow));
  }

  static async getWorkflow(uid) {
    const response = await restApiHttpClient.get(`workflows/${uid}`);
    return new Workflow(response.data);
  }

  static async getWorkflowLog(uid, nodeUid = null) {
    const response = await restApiHttpClient.get(`workflows/${uid}/log`, {params: {node_uid: nodeUid}});
    return response.data;
  }

  static async updateWorkflow(workflow) {
    const response = await restApiHttpClient.post(`workflows/${workflow.uid}`, workflow);
    return new Workflow(response.data);
  }

  static async trashWorkflow(workflow) {
    const response = await restApiHttpClient.delete(`workflows/${workflow.uid}`);
    return new Workflow(response.data);
  }

  static async createWorkflow(workflow) {
    const response = await restApiHttpClient.post(`workflows`, workflow);
    return new Workflow(response.data);
  }
}
